module.exports = __webpack_public_path__ + "static/media/check-square.3ad8700b.svg";